import { useState } from 'react'
import TimeAgo from 'timeago-react'

import CommentForm from './CommentForm'

function Comment({ comment, openLoginModal }) {
  const [displayReplyForm, setDisplayReplyForm] = useState(false)
  const [commentChildren, setCommentChildren] = useState(comment.children || [])

  const toggleReplyForm = () => {
    if (App.State.userSignedIn) {
      setDisplayReplyForm(!displayReplyForm)
    } else {
      openLoginModal()
    }
  }

  const handleCancel = () => {
    setDisplayReplyForm(false)
  }

  const handleNewComment = (newComment) => {
    const tempCommentChildren = commentChildren
    tempCommentChildren.unshift(newComment)
    setCommentChildren(tempCommentChildren)
    setDisplayReplyForm(false)
  }

  return (
    <div
      className="comment"
      style={{
        marginLeft:
          !comment.ancestry || comment.ancestry.includes('/') ? 0 : '2rem',
      }}
    >
      <div className="clearfix mb-2">
        <div className="float-start">
          <img
            src={
              comment.user.avatar ||
              'https://assets.dyler.com/logo/badge_100x100.png'
            }
            className="me-3"
            alt={comment.user.username}
            width={50}
            loading="lazy"
          />
        </div>
        <div className="float-start">
          <p className="h5 mt-0">{comment.user.username}</p>
          {comment.reply_to && (
            <div className="text-muted">
              <i className="fas fa-angle-double-right" />{' '}
              {comment.reply_to.username}
            </div>
          )}
        </div>
      </div>

      <div className="comment-body">
        {comment.comment.split('\n').map((text, index) => (
          <p key={`comment-${comment.id}-p-${index}`}>{text}</p>
        ))}

        <ul className="list-inline py-2">
          {/* <li className="list-inline-item"> */}
          {/*   <i> */}
          {/*     <TimeAgo datetime={comment.created_at} /> */}
          {/*   </i> */}
          {/* </li> */}
          {/* <li className="list-inline-item">&middot;</li> */}
          <li className="list-inline-item">
            <span
              className="text-black"
              onClick={toggleReplyForm}
              style={{ cursor: 'pointer' }}
            >
              <i className="fas fa-reply" />
              {' Reply'}
            </span>
          </li>
        </ul>

        {displayReplyForm && (
          <CommentForm
            key={`comment-form-${comment.id}`}
            placeholder={`Reply to ${comment.user.username}`}
            parent_id={comment.id}
            commentCreated={handleNewComment}
            cancel={handleCancel}
          />
        )}

        {commentChildren &&
          commentChildren.length > 0 &&
          commentChildren.map((commentChild) => (
            <Comment
              comment={commentChild}
              key={`comment-${commentChild.id}`}
            />
          ))}
      </div>
    </div>
  )
}

export default Comment
